"use strict";
import { module } from "../app";

module.service("WorklistUserSettings", [
  "AjaxService",
  "authService",
  function (AjaxService, authService) {
    return {
      getUsersSettings: function () {
        return AjaxService.getAndCache(
          authService.currentMagViewUrl() +
            "/api/worklistUserSettings/settings"
        );
      },
      saveUsersSettings: function (settings) {
        return AjaxService.post(
          authService.currentMagViewUrl() +
            "/api/worklistUserSettings/settings",
          settings
        );
      },
    };
  },
]);



// WEBPACK FOOTER //
// ./src/scripts/domains/worklistUserSettings.js